import React from 'react';

import Icon from '../../../molecules/Icon';

import { color } from '../../../atoms/colors';
import {
  Container,
  Wrapper,
  FormControl,
  Label,
  Input,
  Button,
} from '../styles/Form.styled';

const Form = ({ searchQuery, setSearchQuery, closeModal }) => (
  <Container
    onSubmit={e => {
      e.preventDefault();
    }}
  >
    <Wrapper>
      <FormControl>
        <Icon
          id="magnifying-glass"
          className="search-icon"
          width="20px"
          height="20px"
          strokeColor={color.blue[700]}
        />
        <Label htmlFor="search" aria-label="Search" aria-hidden="true" />
        <Input
          type="text"
          name="search"
          id="search"
          placeholder="Search"
          value={searchQuery}
          onChange={e => {
            setSearchQuery(e.target.value);
          }}
        />
      </FormControl>
      <Button
        type="button"
        name="esc"
        onClick={() => {
          if (searchQuery) {
            setSearchQuery('');
            return;
          }
          closeModal();
        }}
      >
        Esc
      </Button>
    </Wrapper>
  </Container>
);

export default Form;
